//--------------------------------------------------------------------------
// This is an automatically generated file!
// import of interfaces for EnkIWPServer
//--------------------------------------------------------------------------

import { doRequest } from "./do-request"

//--------------------------------------------------------------------------
// TYPE DECLARATIONS
//--------------------------------------------------------------------------

export type TEnkUserGroup = {
 groupId: number;
 description?: string;
 relatienr?: number;
}

export type TEnkUserInfo = {
 username?: string;
 emailaddress?: string;
 displayname?: string;
 profilePicture?: string;
 groups: TEnkUserGroup[];
 roles?: string;
}

export type TEnkLoginResult = {
 mfaNeededWithMethod?: TEnkMFAMethode;
 mfaSetupRequired: boolean;
 mfaSetupKinds: TEnkMFAMethode[];
 user?: TEnkUserInfo;
}

export type TEnkMFAMethode = "none" | "app" | "sms" | "email"

export type TEnkIWPUserKind = "Guest" | "Client" | "Supplier" | "SubContracter" | "Worker"

export type TEnkIWPUserProfile = {
 userId: number;
 username?: string;
 emailAddress?: string;
 status?: number;
 userGroupId?: number;
 fullName?: string;
 aboutMe?: string;
 userKind: TEnkIWPUserKind;
 mobileNumber?: string;
 phoneNumber?: string;
 profilePicture?: string;
}

export type TEnkIWPUserNotifications = {
 notifyNewsletter: boolean;
 notifyCalendarEvents: boolean;
 notifyDocuments: boolean;
}

export type TEnkIwpReportStatus = "active" | "notFound"

export type TEnkIwpReport = {
 name?: string;
 reportFile?: string;
 status: TEnkIwpReportStatus;
 description?: string;
}

export type TEnkIWPDocumentLocation = {
 location?: string;
 name?: string;
}

export type TEnkIWPDocument = {
 location?: string;
 id?: string;
 isSubDir: boolean;
 name?: string;
 docType?: string;
 size: number;
 lastChanged: string /*TDateTime*/;
}

export type TStream = {
  url: string
  size: number
}

export type TEnkDataQueryParamInfo = {
 paramNaam?: string;
 displayLabel?: string;
 paramType?: string;
 defaultWaarde?: string;
 verplicht: boolean;
 volgorde: number;
}

export type TEnkDataQueryInfo = {
 id: number;
 naam?: string;
 beschrijving?: string;
 params: TEnkDataQueryParamInfo[];
}

export type TEnkDataQueryRequest = {
 id: number;
 limit: number;
 offset: number;
 paramNames: string[];
 paramValues: string[];
}

export type TEnkDataQueryColumn = {
 name?: string;
 dataType?: string;
}

export type TEnkDataQueryRow = {
 values: string[];
}

export type TEnkDataQueryResult = {
 columns: TEnkDataQueryColumn[];
 rows: TEnkDataQueryRow[];
 totalCount: number;
 limited: boolean;
}

export type TEnkPhotoInfo = {
 bijlageInhoudId?: string;
 omschrijving?: string;
 bijlageType?: string;
 grootte: number;
}



//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerAuth
//--------------------------------------------------------------------------

export class EnkIWPServerAuth {

  static API_PATH = "api/v1/auth"

  static async login(emailaddress: string, password: string, rememberMe: boolean, mfaCode: string): Promise<TEnkLoginResult> {
    const url = this.API_PATH + `/login`
    return doRequest<TEnkLoginResult, {emailaddress: string; password: string; rememberMe: boolean; mfaCode: string}>("POST", url, {emailaddress,password,rememberMe,mfaCode})
  }

  static async silentLogin(groupId: number): Promise<TEnkLoginResult> {
    const url = this.API_PATH + `/silentLogin?groupId=${encodeURIComponent(groupId)}`
    return doRequest<TEnkLoginResult, number>("POST", url, undefined)
  }

  static async getMfaQRCode(emailaddress: string, password: string): Promise<string> {
    const url = this.API_PATH + `/getMfaQRCode`
    return doRequest<string, {emailaddress: string; password: string}>("POST", url, {emailaddress,password})
  }

  static async sendAuthCode(emailaddress: string, password: string, method: TEnkMFAMethode): Promise<void> {
    const url = this.API_PATH + `/sendAuthCode`
    return doRequest<void, {emailaddress: string; password: string; method: TEnkMFAMethode}>("POST", url, {emailaddress,password,method})
  }

  static async verifyMfaCode(emailaddress: string, password: string, rememberMe: boolean, method: TEnkMFAMethode, mfaCode: string): Promise<TEnkLoginResult> {
    const url = this.API_PATH + `/verifyMfaCode`
    return doRequest<TEnkLoginResult, {emailaddress: string; password: string; rememberMe: boolean; method: TEnkMFAMethode; mfaCode: string}>("POST", url, {emailaddress,password,rememberMe,method,mfaCode})
  }

  static async logout(): Promise<void> {
    const url = this.API_PATH + `/logout`
    return doRequest<void, undefined>("POST", url, undefined)
  }

  static async sendPasswordResetMail(emailaddress: string, state: string): Promise<void> {
    const url = this.API_PATH + `/sendPasswordResetMail`
    return doRequest<void, {emailaddress: string; state: string}>("POST", url, {emailaddress,state})
  }

  static async passwordReset(newPassword: string, code: string): Promise<string> {
    const url = this.API_PATH + `/resetPassword`
    return doRequest<string, {newPassword: string; code: string}>("POST", url, {newPassword,code})
  }

  static async getWelcomePage(): Promise<string> {
    const url = this.API_PATH + `/welcomePage`
    return doRequest<string, undefined>("GET", url, undefined)
  }

  static async setUserGroup(aGroup: number): Promise<TEnkUserInfo> {
    const url = this.API_PATH + `/setUserGroup`
    return doRequest<TEnkUserInfo, {aGroup: number}>("POST", url, {aGroup})
  }

  static async getProfile(): Promise<TEnkIWPUserProfile> {
    const url = this.API_PATH + `/profile`
    return doRequest<TEnkIWPUserProfile, undefined>("GET", url, undefined)
  }

  static async saveProfile(aProfile: TEnkIWPUserProfile): Promise<void> {
    const url = this.API_PATH + `/profile`
    return doRequest<void, TEnkIWPUserProfile>("POST", url, aProfile)
  }

  static async getNotifications(): Promise<TEnkIWPUserNotifications> {
    const url = this.API_PATH + `/notifications`
    return doRequest<TEnkIWPUserNotifications, undefined>("GET", url, undefined)
  }

  static async saveNotifications(aNotifications: TEnkIWPUserNotifications): Promise<void> {
    const url = this.API_PATH + `/notifications`
    return doRequest<void, TEnkIWPUserNotifications>("POST", url, aNotifications)
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerReports
//--------------------------------------------------------------------------

export class EnkIWPServerReports {

  static API_PATH = "api/v1/reports"

  static async getList(groupId: number): Promise<TEnkIwpReport[]> {
    const url = this.API_PATH + `/list?groupId=${encodeURIComponent(groupId)}`
    return doRequest<TEnkIwpReport[], number>("GET", url, undefined)
  }

  static async buildReport(groupId: number, reportName: string, params: string[]): Promise<ArrayBuffer> {
    const url = this.API_PATH + `/build`
    return doRequest<ArrayBuffer, {groupId: number; reportName: string; params: string[]}>("POST", url, {groupId,reportName,params})
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerDocuments
//--------------------------------------------------------------------------

export class EnkIWPServerDocuments {

  static API_PATH = "api/v1/documents"

  static async getLocations(groupId: number): Promise<TEnkIWPDocumentLocation[]> {
    const url = this.API_PATH + `/getLocations`
    return doRequest<TEnkIWPDocumentLocation[], {groupId: number}>("POST", url, {groupId})
  }

  static async getDocuments(groupId: number, location: string): Promise<TEnkIWPDocument[]> {
    const url = this.API_PATH + `/getDocuments`
    return doRequest<TEnkIWPDocument[], {groupId: number; location: string}>("POST", url, {groupId,location})
  }

  static async getDocument(groupId: number, location: string, id: string): Promise<TStream> {
    const url = this.API_PATH + `/getDocument`
    return doRequest<TStream, {groupId: number; location: string; id: string}>("POST", url, {groupId,location,id})
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerDataQueries
//--------------------------------------------------------------------------

export class EnkIWPServerDataQueries {

  static API_PATH = "api/v1/dataqueries"

  static async getList(groupId: number): Promise<TEnkDataQueryInfo[]> {
    const url = this.API_PATH + `/list?groupId=${encodeURIComponent(groupId)}`
    return doRequest<TEnkDataQueryInfo[], number>("GET", url, undefined)
  }

  static async getData(request: TEnkDataQueryRequest): Promise<TEnkDataQueryResult> {
    const url = this.API_PATH + `/getData`
    return doRequest<TEnkDataQueryResult, TEnkDataQueryRequest>("POST", url, request)
  }


}
//--------------------------------------------------------------------------
// INTERFACE Enk.IWPServer.Interfaces - IEnkIWPServerPhotos
//--------------------------------------------------------------------------

export class EnkIWPServerPhotos {

  static API_PATH = "api/v1/photos"

  static async getList(table: string, keyValue: string): Promise<TEnkPhotoInfo[]> {
    const url = this.API_PATH + `/list?table=${encodeURIComponent(table)}&keyValue=${encodeURIComponent(keyValue)}`
    return doRequest<TEnkPhotoInfo[], {table: string; keyValue: string}>("GET", url, undefined)
  }

  static async getImage(id: string): Promise<ArrayBuffer> {
    const url = this.API_PATH + `/image?id=${encodeURIComponent(id)}`
    return doRequest<ArrayBuffer, string>("GET", url, undefined)
  }

  static async downloadAll(table: string, keyValue: string): Promise<ArrayBuffer> {
    const url = this.API_PATH + `/downloadAll?table=${encodeURIComponent(table)}&keyValue=${encodeURIComponent(keyValue)}`
    return doRequest<ArrayBuffer, {table: string; keyValue: string}>("GET", url, undefined)
  }


}
